export default "__VITE_ASSET__CGYs3Kpe__"